import React from 'react'

function SvgPlanTarifaire() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
<path d="M6.54756 6.86364C7.19344 4.35421 9.47141 2.5 12.1824 2.5C15.3957 2.5 18.0006 5.10489 18.0006 8.31818C18.0006 10.88 16.3449 13.0551 14.0451 13.8318M13.6356 12.6818C13.6356 15.8951 11.0307 18.5 7.81745 18.5C4.60416 18.5 1.99927 15.8951 1.99927 12.6818C1.99927 9.46852 4.60416 6.86364 7.81745 6.86364C11.0307 6.86364 13.6356 9.46852 13.6356 12.6818Z" stroke="currentColor" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
  )
}

export default SvgPlanTarifaire